<app-content-management [cmsName]="'Privacy Policy'" [pageName]="'privacy-policy'"></app-content-management>